import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import SectionCard from './SectionCard';

export default function WorkflowGuideCard({
  title = 'Workflow Guide',
  subheader = 'This request path is applied after you submit.',
  steps = [],
  tone = 'dashboard',
}) {
  const theme = useTheme();

  if (!Array.isArray(steps) || steps.length === 0) return null;

  return (
    <SectionCard title={title} subheader={subheader} tone={tone}>
      <Stack spacing={1.1}>
        {steps.map((step, idx) => (
          <Box
            key={`${step.actor}-${step.action}-${idx}`}
            sx={{
              p: 1.2,
              borderRadius: 2,
              border: '1px solid',
              borderColor: alpha(theme.palette.primary.main, 0.14),
              backgroundColor: alpha(theme.palette.primary.main, 0.03),
            }}
          >
            <Stack direction="row" spacing={1} alignItems="flex-start">
              <Chip
                size="small"
                color="primary"
                label={`Step ${idx + 1}`}
                variant="outlined"
                sx={{ mt: 0.1, fontWeight: 700, minWidth: 70 }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 800 }}>
                  {step.actor}
                </Typography>
                <Typography variant="body2">{step.action}</Typography>
                {step.note ? (
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.3 }}>
                    {step.note}
                  </Typography>
                ) : null}
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>
    </SectionCard>
  );
}
